import { useEffect, useMemo, useState } from 'react';
import { collection, getDocs, query } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuth } from '../contexts/AuthContext';
import { User, AccessScope, getAccessScope, isFullAccess } from '../types';

// Escopo de acesso do usuário logado para filtrar os dados das telas.
// - Acesso total (admin/pricing/gerente_nacional): { full: true } (sem filtro).
// - Gestor (gerente/coordenador/supervisor): carrega os usuários e calcula os
//   vendedores/CODVENDs da hierarquia dele.
// - Vendedor: só ele mesmo.
export function useAccessScope(): AccessScope {
  const { user } = useAuth();
  const [sellers, setSellers] = useState<User[]>([]);

  useEffect(() => {
    // Só GESTOR escopado precisa da lista de usuários. Acesso total vê tudo; vendedor tem escopo próprio
    // (getAccessScope trata role 'seller' sem ler `users`, que ele nem tem permissão de listar).
    if (!user || isFullAccess(user.role) || user.role === 'seller') return;
    getDocs(query(collection(db, 'users')))
      .then((s) => setSellers(s.docs.map((d) => ({ id: d.id, ...d.data() })) as User[]))
      .catch((e) => { console.warn('useAccessScope: falha ao ler users (escopo ficará vazio):', e?.code || e?.message || e); });
  }, [user]);

  return useMemo(() => getAccessScope(user, sellers), [user, sellers]);
}
